import React, {useState} from 'react';
import Dialog from '../adapters/Dialog'
import Button from '../adapters/Button';

//import {toggleModal} from '../../redux/application';

import Grid from "@material-ui/core/Grid";
import {Form, FormSpy} from "react-final-form";
import {makeStyles} from "@material-ui/core/styles";
import Select from "../adapters/FormSelect";
import {history} from "../../App";
import {useRouteMatch} from "react-router-dom";
import {POLL_PAGE} from "../../constants/app-constants";

const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      //marginTop: theme.spacing(3),
    }
  })
);

export default function AskPollEducation({open, toggle, pollId, educationList}) {

  const [hasErrors, toggleHasErrors] = useState(false);

  let {path} = useRouteMatch();

  //см. https://final-form.org/docs/react-final-form/faq
  //How can I trigger a submit from outside my form?
  let submit;

  async function submitRegister({educationId}) {
    history.push(`${path}${POLL_PAGE}/${pollId}?educationId=${educationId}&action=edit`);
  }

  function validate(values) {
    let errors = {};
    if (!values.educationId)
      errors.educationId = 'Необхідно обрати навчання';
    return errors;
  }

  const classes = useStyles();

  const content =
    <Form
      onSubmit={submitRegister}
      validate={validate}
      render={({handleSubmit}) => {
        submit = handleSubmit;
        return (
          <form className={classes.form} onSubmit={handleSubmit} noValidate>
            <Grid container>
              <Grid item xs={12}>
                <Select
                  label="Оберіть до якого навчання відноситься опитування"
                  content={educationList}
                  idKey="educationId"
                  nameKey="educationName"
                  name="educationId"
                />
              </Grid>
            </Grid>
            <FormSpy subscription={{hasValidationErrors: true}}
                     onChange={props => {
                       //Говнокод inside
                       //Состояние формы недоступно извне формы, а нам очень хочется
                       //FormSpy будет рендерится когда поменяется hasValidationErrors
                       //В этот момент мы пропихиваем в стейт значение этого флага
                       //Без form spy это был бы бесконечный цикл, а так один лишний рендер
                       //setTimeout нужен чтобы подавить ворнинг реакта что мы мол в рендеринге меняем стейт
                       setTimeout(() => toggleHasErrors(props.hasValidationErrors), 0)
                     } }
            />
          </form>
        )
      }}
    />


  const actions = <React.Fragment>
    <Button disabled={hasErrors} onClick={() => submit()}>Далі </Button>
    <Button onClick={() => toggle(false)}> Відмінити </Button>
  </React.Fragment>;

  return (
    <Dialog
      open={open}
      maxWidth="lg"
      title="Вибір навчання для опитування"
      content={content}
      actions={actions}
    />)

}